<template>
  <div class="lg:tw-flex lg:tw-justify-end lg:tw-w-[200px]">
    <button type="button"
      class="save-or-add-to-cart-btn tw-bg-solYellow tw-border-none tw-text-black tw-font-semibold tw-rounded-full tw-text-base tw-h-10 lg:tw-h-[55px] tw-px-8 tw-min-w-[8rem] tw-cursor-pointer tw-flex tw-justify-center tw-items-center hover:tw-bg-solYellowDark tw-transition-colors"
      @click="$emit('click')">
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SaveOrAddToCartButton',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
};
</script>
